import React, { useEffect, useRef, useState } from 'react';
import './styles/Download.css';
import 'animate.css';
// import IconButton from '@mui/material/IconButton';
// import ExpandMore from '@mui/icons-material/ExpandMore';
// import FileDownload from '@mui/icons-material/FileDownload';
// import HeroVideoCover from '../../assets/video/Walkthrough-English.mp4';
// import HeroVideoCover2 from '../../assets/video/Walkthrough-French.mp4';
import Typewriter from 'typewriter-effect';

// import AppstoreDark from '../../assets/svgs/appstore-dark.svg';
import AppstoreLight from '../../assets/svgs/appstore-light.svg';
// import GoogleplayDark from '../../assets/svgs/googleplay-dark.svg';
import GoogleplayLight from '../../assets/svgs/googleplay-light.svg';

import DOMPurify from 'dompurify';
import { useTranslation } from 'react-i18next';

import StickyNavbarOnePager from '../sticky-navbar/StickyNavbarOnePager';

import DownloadIMG_One from '../../assets/backgrounds/subscribe-bg.png';

import Check from '@mui/icons-material/Check';
import LocationOn from '@mui/icons-material/LocationOn';
import QuestionMark from '@mui/icons-material/QuestionMark';
import NotificationsActive from '@mui/icons-material/NotificationsActive';


function Download({ toggleTheme }) {
    // Refs for each element to be animated
    const heroImageRef = useRef(null);
    const heroVideoRef = useRef(null);
    const typewriterRef = useRef(null);
    const leadTextRef = useRef(null);
    const joinNowBtnRef = useRef(null);
    const scrollMoreRef = useRef(null);

    const { t } = useTranslation();
    const [heroImgLoaded, setHeroImgLoaded] = useState(false);

    // No inline video toggle in this view

    useEffect(() => {
        const options = {
            root: null, // Uses the viewport as the root
            threshold: 0.2, // 20% visibility required to trigger
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    // Add specific animation classes for each element when visible
                    if (entry.target === heroImageRef.current) {
                        entry.target.classList.add('animate__animated', 'animate__fadeInRight');
                    } else if (entry.target === heroVideoRef.current) {
                        entry.target.classList.add('animate__animated', 'animate__fadeInTopRight', 'animate__delay-2s');
                    } else if (entry.target === typewriterRef.current) {
                        entry.target.classList.add('animate__animated', 'animate__fadeInLeft');
                    } else if (entry.target === leadTextRef.current) {
                        entry.target.classList.add('animate__animated', 'animate__fadeInLeft');
                    } else if (entry.target === joinNowBtnRef.current) {
                        entry.target.classList.add('animate__animated', 'animate__fadeInRight');
                    } else if (entry.target === scrollMoreRef.current) {
                        entry.target.classList.add('animate__animated', 'animate__fadeInLeft', 'animate__delay-2s');
                    }
                }
            });
        }, options);

        // Observe each element
        if (heroImageRef.current) observer.observe(heroImageRef.current);
        if (heroVideoRef.current) observer.observe(heroVideoRef.current);
        if (typewriterRef.current) observer.observe(typewriterRef.current);
        if (leadTextRef.current) observer.observe(leadTextRef.current);
        if (joinNowBtnRef.current) observer.observe(joinNowBtnRef.current);
        if (scrollMoreRef.current) observer.observe(scrollMoreRef.current);

        // Cleanup observer when the component unmounts
        return () => {
            if (heroImageRef.current) observer.unobserve(heroImageRef.current);
            if (heroVideoRef.current) observer.unobserve(heroVideoRef.current);
            if (typewriterRef.current) observer.unobserve(typewriterRef.current);
            if (leadTextRef.current) observer.unobserve(leadTextRef.current);
            if (joinNowBtnRef.current) observer.unobserve(joinNowBtnRef.current);
            if (scrollMoreRef.current) observer.unobserve(scrollMoreRef.current);
        };
    }, []);

    return (
        <section id="home" className='download-wrapper section'>

            <StickyNavbarOnePager toggleTheme={toggleTheme} />

            <div className="container col-xxl-8 px-4 py-5">
                <div className="row flex-lg-row-reverse align-items-center g-5 py-5">
                    
                    {/* Hero text and call-to-action buttons */} 
                    <div className="col-lg-6 order-2 order-md-1 text-center text-lg-start hero-content-wrapper">
                        <h1 ref={typewriterRef} className="display-5 fw-bold lh-1">
                            <Typewriter
                                options={{
                                    strings: [
                                        DOMPurify.sanitize(t('op.hero.header1onDownload')),
                                        DOMPurify.sanitize(t('op.hero.header2onDownload')),
                                        DOMPurify.sanitize(t('op.hero.header3onDownload')),
                                    ],
                                    autoStart: true,
                                    loop: true,
                                    delay: 75,
                                    deleteSpeed: 30,
                                    wrapperClassName: 'typewriter-text',
                                    cursorClassName: 'typewriter-cursor',
                                    html: true,
                                }}
                            />
                        </h1>
                        <p ref={leadTextRef} className="lead landing-desc" style={{ maxWidth: 640, whiteSpace: 'pre-line', marginLeft: 'auto', marginRight: 'auto' }}>
                            {t('op.landing.description')}
                        </p>
                        <div ref={joinNowBtnRef} className="hero-buttons d-grid gap-2 d-md-flex justify-content-center justify-content-md-start">
                            <a
                                href="https://play.google.com/store/apps/details?id=com.zonezapp&hl=en"
                                className="btn btn-dark btn-lg px-3 py-2 mb-3 rounded-3">
                                <img
                                    src={GoogleplayLight}
                                    alt="Get it on Google Play"
                                    width={150}
                                    height={150}
                                    loading="lazy"
                                    decoding="async"
                                />
                            </a>
                            <a
                                href="https://apps.apple.com/app/zonezapp/id6593563694"
                                className="btn btn-dark btn-lg px-3 py-2 mb-3 rounded-3">
                                <img
                                    src={AppstoreLight}
                                    alt="Download on the App Store"
                                    width={150}
                                    height={150}
                                    loading="lazy"
                                    decoding="async"
                                />
                            </a>
                        </div>
                    </div>
                    
                    {/* Hero image/video container */}
                    <div ref={heroImageRef} className={`col-12 col-md-10 col-lg-6 py-5 download-image-container order-1 order-md-2 ${heroImgLoaded ? '' : 'is-loading'}`}>
                        <img
                            src={DownloadIMG_One}
                            className='shadow rounded-3 download-hero-img'
                            alt="ZoneZapp preview"
                            loading="lazy"
                            decoding="async"
                            fetchpriority="low"
                            sizes="(max-width: 576px) 320px, (max-width: 768px) 480px, (max-width: 992px) 680px, 540px"
                            onLoad={() => setHeroImgLoaded(true)}
                        />
                    </div>
                </div> 



            </div>

            <div className="container px-4 py-5" id="icon-grid">
                <h2 className="pb-2 hiw-heading border-bottom">{t('op.hero.how_it_works')}</h2>

                <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4 py-5">
                    <div className="col d-flex align-items-start">
                        <div className="icon-square glassmorphism flex-shrink-0 me-3">
                            <Check className="bi" width="1.50em" height="1.50em" />
                        </div>
                        <div>
                            <h4 className="fw-bold mb-0 download-header">{t('op.hero.step1.action')}</h4>
                            <p>{t('op.hero.step1.description')}</p>
                        </div>
                    </div>
                    <div className="col d-flex align-items-start">
                        <div className="icon-square glassmorphism flex-shrink-0 me-3">
                            <LocationOn className="bi" width="1.50em" height="1.50em" />
                        </div>
                        <div>
                            <h4 className="fw-bold mb-0 download-header">{t('op.hero.step2.action')}</h4>
                            <p>{t('op.hero.step2.description')}</p>
                        </div>
                    </div>
                    <div className="col d-flex align-items-start">
                        <div className="icon-square glassmorphism flex-shrink-0 me-3">
                            <QuestionMark className="bi" width="1.50em" height="1.50em" />
                        </div>
                        <div>
                            <h4 className="fw-bold mb-0 download-header">{t('op.hero.step3.action')}</h4>
                            <p>{t('op.hero.step3.description')}</p>
                        </div>
                    </div>
                    <div className="col d-flex align-items-start">
                        <div className="icon-square glassmorphism flex-shrink-0 me-3">
                            <NotificationsActive className="bi" width="1.50em" height="1.50em" />
                        </div>
                        <div>
                            <h4 className="fw-bold mb-0 download-header">{t('op.hero.step4.action')}</h4>
                            <p>{t('op.hero.step4.description')}</p>
                        </div>
                    </div>
                </div>
            </div>

        </section>
    );
}

export default Download;